import React from 'react';
import { observer } from 'mobx-react';
import './PurchaseUser.less';
import InputItem from 'antd-mobile/lib/input-item';
import autobind from 'autobind-decorator';

interface PurchaseUserPropsType {
    prefixCls?: string;
    obtainCode?: () => void;
    codeTime?: number;
    onSaveData: (flag: string, data: any) => void;
    isAgain: boolean
}

@observer
class PurchaseUser extends React.Component<PurchaseUserPropsType, any> {
    static defaultProps = {
        prefixCls: 'purchase-user'
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            name: '', // 用户姓名
            code: '', // 验证码
            phone: '', // 手机号
            isNoWriteName: false,
            isNoWritePhone: false
        };
    }

    @autobind
    onChangeName(event) {
        const {onSaveData} = this.props;
        if (event == ' ') return;
        this.setState({
            name: event
        });
        if (onSaveData) {
            onSaveData('trueName', event);
            sessionStorage.setItem('trueName', event);
        }
    }

    @autobind
    onChangePhone(event) {
        const {onSaveData} = this.props;
        this.setState({
            phone: event
        });
        if (onSaveData) {
            onSaveData('truePhone', event);
            sessionStorage.setItem('truePhone', event);
        }
    }

    @autobind
    onChangeCode(event) {
        const {onSaveData} = this.props;
        this.setState({
            code: event
        });
        if (onSaveData) {
            onSaveData('code', event);
        }
    }

    renderState(name, phone, isDisable?) {
        this.setState({
            name, phone,
            isNoWriteName: name !== '' && isDisable,
            isNoWritePhone:  phone !== '' && isDisable
        });
    }

    @autobind
    _showBtn(): void {
        const {codeTime = 0, isAgain, obtainCode, prefixCls} = this.props;
        let btnNode: any = null;
        if (codeTime <= 0) {
            if (isAgain) {
                btnNode =  (
                    <div className={`${prefixCls}-btn ${prefixCls}-btnAgain`} onClick={obtainCode}>重新获取</div>
                )
            } else {
                btnNode =  (
                    <div className={`${prefixCls}-btn`} onClick={obtainCode}>获取验证码</div>
                )
            }
        } else {
            btnNode =  (
                <div className={`${prefixCls}-btn ${prefixCls}-btnTime`} onClick={obtainCode}>{codeTime}秒 后重发</div>
            )
        }
        return btnNode
    }

    render() {
        const {prefixCls} = this.props;
        const {phone, name, code, isNoWriteName, isNoWritePhone} = this.state;
        return (
            <div className={`${prefixCls}`}>
                <div className={`${prefixCls}-name-box`}>
                    <InputItem
                        maxLength={15}
                        value={name}
                        onChange={this.onChangeName}
                        placeholder="真实姓名"
                        className="trueName"
                        disabled={isNoWriteName}
                    />
                </div>
                <div className={`${prefixCls}-name-box`}>
                    <InputItem
                        type="number"
                        placeholder="手机号"
                        value={phone}
                        maxLength={11}
                        onChange={this.onChangePhone}
                        className="truePhone"
                        disabled={isNoWritePhone}
                    />
                </div>
                <div className={`${prefixCls}-code-box`}>
                    <div className={`${prefixCls}-code`}>
                        <InputItem
                            type="number"
                            placeholder="验证码"
                            value={code}
                            maxLength={6}
                            onChange={this.onChangeCode}
                            ref={'code_input'}
                            className='antd_input_ref'
                        />
                    </div>
                    {this._showBtn()}
                </div>
            </div>
        );
    }
}

export default PurchaseUser;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/giftComp/purchaseUser/PurchaseUser.tsx